module.exports = __webpack_public_path__ + "img/icon-long-1-1.aee231b2.png";